import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function AiPreviewLoading() {
  const { t } = useLanguage();
  const [index, setIndex] = useState(0);
  const facts = t("aiPreview.loading.facts");

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % facts.length);
    }, 7000);

    return () => window.clearInterval(timer);
  }, [facts.length]);

  return (
    <div className="max-w-full rounded-2xl border border-[#66C95E]/25 bg-[#66C95E]/10 p-5 text-center dark:border-[#66C95E]/25 dark:bg-[#66C95E]/10 sm:rounded-3xl">
      <Loader2 className="mx-auto mb-3 h-8 w-8 animate-spin text-[#66C95E]" />
      <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[#2f7f2a] dark:text-[#66C95E]">
        {t("aiPreview.loading.title")}
      </p>
      <p className="mx-auto mt-3 max-w-md text-base font-semibold leading-relaxed text-slate-800 dark:text-white/85">
        {t("aiPreview.loading.waitTime")}
      </p>
      <p className="mt-3 text-base text-slate-700 dark:text-white/75">
        <span className="font-semibold">{t("aiPreview.loading.didYouKnow")}</span> {facts[index]}
      </p>
    </div>
  );
}
